import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { io } from "socket.io-client";
import conversationsApi from "../api/conversations.api";
import uploadsApi from "../api/uploads.api";
import "../css/ChatBox.css";
import Cookies from "js-cookie";



const ChatBox = () => {
  const { conversationId } = useParams();
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [currentClient, setCurrentClient] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const messagesEndRef = useRef(null);
  const socketRef = useRef(null);
  const buttonRef = useRef(null);
  const fileInputRef = useRef(null);


  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      buttonRef.current?.click();
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  useEffect(() => {
    const socketUrl = process.env.REACT_APP_API_BASE_URL;
    console.log("Connecting to WebSocket at:", socketUrl);

    if (!socketRef.current) {
      socketRef.current = io(socketUrl, {
        transports: ["websocket"],
        reconnection: true,
        query: { conversationId },
      });

      socketRef.current.on("connect", () => {
        console.log(" Connected to WebSocket with conversationId:", conversationId);
        console.log(" WebSocket ID:", socketRef.current.id); // Log socket ID

        // Emit join event with conversationId
        socketRef.current.emit("join_conversation", { conversationId });

        // Update the socket ID to conversationId for tracking
        socketRef.current.id = conversationId;
      });

      socketRef.current.on("receive_message", (data) => {
        console.log(" Received message:", data);
        if (data.conversationId === conversationId) {
          setMessages((prev) => [...prev, data.message]);
        }
      });

      socketRef.current.on("disconnect", () => {
        console.warn(" WebSocket disconnected!");
      });

      socketRef.current.on("connect_error", (err) => {
        console.error(" WebSocket Connection Error:", err);
      });
    }


    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [conversationId]);

  useEffect(() => {
    if (socketRef.current) {
      console.log(`Forcing rejoin to room ${conversationId}`);
      socketRef.current.emit("join_conversation", { conversationId });
    }
  }, [conversationId]);


  //  Fetch Existing Messages When Conversation Changes
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await conversationsApi.getConversationById(conversationId);
        if (response) {
          setCurrentClient(response.response.name);
          setMessages(response.response.messages || []);
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, [conversationId]);

  //  Scroll to Bottom When Messages Update
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  //  Send Message
  const sendMessage = async () => {
    if ((!newMessage.trim() && !selectedFile) || !socketRef.current) return;

    let fileUrl = null;
    let fileSize = null;
    let fileName = null;

    if (selectedFile) {
      try {
        const formData = new FormData();
        formData.append("file", selectedFile);

        const uploadRes = await uploadsApi.uploadFile(formData);
        fileUrl = `${process.env.REACT_APP_API_BASE_URL}${uploadRes.data.url}`;
        fileSize = selectedFile.size;
        fileName = selectedFile.name;
      } catch (error) {
        console.error("File upload failed:", error);
        return;
      }
    }

    const msg = {
      sender: 2,
      text: newMessage,
      created: new Date().toISOString(),
      admin_name: Cookies.get("currentUser"),
      isAnswer: true,
      fileUrl,
      fileSize,
      fileName,
    };

    socketRef.current.emit("send_message", { conversationId, message: msg });

    setNewMessage("");
    setSelectedFile(null);
  };



  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, index) => (
          <div key={index} className={`chat-message ${msg.sender === 1 ? "user-msg" : "admin-msg"}`}>
            <div className="message-header">
              <strong>{msg.sender === 1 ? currentClient : msg.admin || "Admin"}</strong>
            </div>
            <div className="message-content">
              {msg.text && <p>{msg.text}</p>}

              {msg.fileUrl && (
                <div className="file-preview">
                  {/* If image */}
                  {msg.fileUrl.match(/\.(jpeg|jpg|gif|png)$/i) ? (
                    <img
                      src={msg.fileUrl}
                      alt={msg.fileName || "uploaded image"}
                      className="chat-image-preview"
                    />
                  ) : (
                    <a href={msg.fileUrl} target="_blank" rel="noopener noreferrer">
                      {msg.fileName || "Download file"}
                    </a>
                  )}
                </div>
              )}
            </div>

            <div className="message-time">{new Date(msg.created).toLocaleTimeString()}</div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input">
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Напиши одговор..."
          onKeyDown={handleKeyDown}
        />

        {/* File Upload Icon */}
        <div className="file-upload-wrapper">
          <label htmlFor="file-upload" className="file-upload-icon">
            <img
              src="/icons/upload.svg"
              alt="Upload"
              style={{ width: 20, height: 20, cursor: "pointer", marginLeft: "8px" }}
            />
          </label>
          <input
            id="file-upload"
            type="file"
            className="file-upload-input"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
        </div>

        {/* Show file name if file is selected */}
        {selectedFile && (
          <span className="file-name-preview">
            {selectedFile.name.length > 20
              ? selectedFile.name.substring(0, 20) + "..."
              : selectedFile.name}
          </span>
        )}

        <button onClick={sendMessage} ref={buttonRef}>Испрати</button>
      </div>
    </div>
  );
};

export default ChatBox;
